module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllItem),
      expression: "selectAllItem"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllItem) ? _vm._i(_vm.selectAllItem, null) > -1 : (_vm.selectAllItem)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAllItem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllItem = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllItem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllItem = $$c
        }
      }, _vm.selectAll]
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v(_vm._s(_vm.type === 'alias' ? '別名' : '描述（上限 500 字）'))]), _vm._v(" "), (_vm.type === 'description') ? _c('th', {
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("警語（上限 200 字）")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    staticClass: "actions-td",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品項編輯")]), _vm._v(" "), _c('th', {
    staticClass: "actions-td",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品項刪除")])])]), _vm._v(" "), (!_vm.settingList.length) ? _c('tbody', [_vm._m(0)]) : _c('tbody', _vm._l((_vm.settingList), function(item, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selectItem),
        expression: "item.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.selectItem) ? _vm._i(item.selectItem, null) > -1 : (item.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = item.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selectItem", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_vm._l((item.item_list), function(item) {
      return _c('div', {
        staticClass: "col-xs-8"
      }, [(_vm.type === 'alias') ? _c('span', [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.type === 1) ? _c('span', [_vm._v(_vm._s(item.description))]) : _vm._e()])
    }), _vm._v(" "), (_vm.type === 'description' && _vm.checkEmptyBtnShow(item.item_list, 1)) ? _c('div', {
      staticClass: "col text-right"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.emptyDescrption(item.item_list, item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.type === 'description') ? _c('td', [_c('div', {
      staticClass: "row"
    }, [_vm._l((item.item_list), function(item) {
      return _c('div', {
        staticClass: "col-xs-8"
      }, [(item.type === 2) ? _c('span', [_vm._v(_vm._s(item.description))]) : _vm._e()])
    }), _vm._v(" "), (_vm.checkEmptyBtnShow(item.item_list, 2)) ? _c('div', {
      staticClass: "col text-right"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.emptyWarning(item.item_list, item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.vendor_custom_id))])]), _vm._v(" "), _c('td', [(item.is_enabled) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("停用")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.upElement(item.id, _vm.type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline-block",
      on: {
        "click": function($event) {
          return _vm.delElement(item.id, _vm.type)
        }
      }
    }, [_vm._m(1, true)])])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("無資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delDesAlisModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7717e426"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/ProdSettingTable.vue
// module id = 2483
// module chunks = 1